module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/15-5fe088aa0538d3820e9ff18b7d877578.jpg";